module.exports = __webpack_public_path__ + "media/packs/src/assets/images/sms-and-email-69e3368d67645c2573179d5306ca2f50.png";